import { render } from "./sidebar_web.vue?vue&type=template&id=69010ea1&scoped=true"
import script from "./sidebar_web.vue?vue&type=script&lang=js"
export * from "./sidebar_web.vue?vue&type=script&lang=js"

import "./sidebar_web.vue?vue&type=style&index=0&id=69010ea1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69010ea1"]])

export default __exports__